import { createAsyncThunk } from '@reduxjs/toolkit';
import { AdminsAPI } from '@/api';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import { IAdminProfileDTO, IAdminProfileResponse, IChangePasswordDTO } from '@/models/admins.model';
import { ADMIN_PROFILE_SLICE_NAME } from './models';

export const getAdminProfile = createAsyncThunk<IAdminProfileResponse, void, { serializedErrorType: IApiError }>(
  `${ADMIN_PROFILE_SLICE_NAME}/getAdminProfile`,
  async () => {
    const response = await AdminsAPI.getAdminProfile();
    return response.data;
  },
  { serializeError: formatApiError },
);

export const updateAdminProfile = createAsyncThunk<
  IAdminProfileResponse,
  IAdminProfileDTO,
  { serializedErrorType: IApiError }
>(
  `${ADMIN_PROFILE_SLICE_NAME}/updateAdminProfile`,
  async (data: IAdminProfileDTO) => {
    const response = await AdminsAPI.updateAdminProfile(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const changePassword = createAsyncThunk<
  IAdminProfileResponse,
  IChangePasswordDTO,
  { serializedErrorType: IApiError }
>(
  `${ADMIN_PROFILE_SLICE_NAME}/changePassword`,
  async (data: IChangePasswordDTO) => {
    const response = await AdminsAPI.changePassword(data);
    return response.data;
  },
  { serializeError: formatApiError },
);
